var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.698.96s4.401.916 11.357 2.497c3.658.831 12.248 3.206 15.638 8.796 2.309 3.696 1.16 8.593-2.56 10.918a7.963 7.963 0 01-7.773.369.76.76 0 00-.69.054c-.348.217-.516.665-.282.93 1.52 1.825 5.716 6.055 11.213 4.916l-13.149 8.216c3.419-4.466 1.496-10.082.497-12.233-.135-.327-.611-.371-.959-.154-.198.124-.32.37-.351.596A7.925 7.925 0 0113.9 32.69c-3.72 2.325-8.626 1.21-10.935-2.485C-.5 24.66 1.132 15.9 1.988 12.246 3.617 5.302 4.698.96 4.698.96zm9.641 11.345l-5.306-4.46 1.66 6.74-5.93 3.704 6.944.458 1.684 6.724 2.632-6.441 6.944.457-5.331-4.445L20.268 8.6l-5.929 3.705z",
    fill: "#fff"
  })));
}
SvgSpade.displayName = 'Spade';
export default SvgSpade;